import { Injectable } from "@angular/core";
import { Adapter } from "../adapter";
import { LTSAEvergreen } from "./constants";


export class PipelineLTSASearch {
    constructor(
        public pipelineLtsaId: string,
        public contractLength: string,
        public contractLengthDesc: string,
        public contractExpiration: string,
        public ltsaStatusId: string,
        public ltsaStatusDesc: string,
        public recordStatusId: string,
        public recordStatusDesc: string,
        public companyId: string,
        public companyName: string,
        public preferredContractor: string,
        public qcDate: string,
        public physAddressV1: string,
        public mailAddressV1: string,
        public offshoreBlockV1: string
    ) { }
}

@Injectable({
    providedIn: 'root',
})
export class PipelineLTSASearchAdapter implements Adapter<PipelineLTSASearch> {
    adapt(item: any): PipelineLTSASearch {
        return new PipelineLTSASearch(
            item.PIPE_LTSA_ID, 
            item.CONTRACT_LENGTH,
            item.CONTRACT_LENGTH === LTSAEvergreen.Code ? LTSAEvergreen.Letter : item.CONTRACT_LENGTH, 
            item.CONTRACT_EXPIRATION,
            item.LTSA_STATUS_ID, 
            item.LTSA_STATUS_DESC, 
            item.RECORD_STATUS, 
            item.RECORD_STATUS_DESC, 
            item.COMPANY_ID, 
            item.COMPANY_NAME,
            item.PREFERRED_CONTRACTOR, 
            item.QC_DATE,
            item.PHYS_ADDRESS_V1, 
            item.MAIL_ADDRESS_V1,
            item.OFFSHORE_BLOCK_V1 
        );
    }
}


